<template>
    <section class="location-edit-view">
        <div class="modal-header">
            <h3 v-if="location.id">Location Edit</h3>
            <h3 v-else>Add Location</h3>
            <p class="required-fields">All fields marked with * are required</p>
        </div>
        <app-form
            ref="locationForm"
            :model="location"
            :rules="rules"
            @submit.native.prevent="submit">
            <app-form-item label="Name" prop="name">
                <app-input
                    id="name"
                    v-model="location.name"
                    :disabled="location.id != null"
                    autofocus/>
            </app-form-item>
            <app-form-item label="Notes" prop="note">
                <app-input id="note" v-model="location.note" type="textarea"/>
            </app-form-item>

            <div class="modal-footer">
                <app-button
                    v-if="location.id"
                    :border="false"
                    type="danger"
                    size="large"
                    tabindex="1"
                    style="float:left"
                    plain
                    @click="remove">Delete</app-button>
                <app-button
                    :loading="isSaving"
                    type="primary"
                    native-type="submit"
                    size="large">Save</app-button>
            </div>
        </app-form>
    </section>
</template>
<script>
import Location from '@/store/models/Location'

export default {
    name: 'location-edit-view',
    inject: ['modalOptions'],
    props: ['location_id'],
    data() {
        return {
            location: new Location(Location.find(this.location_id)) || new Location(),
            isSaving: false,
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Please enter a name',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    methods: {
        submit() {
            this.$refs['locationForm'].validate(valid => {
                if (valid) {
                    this.location.id ? this.update() : this.create()
                }
            })
        },
        create() {
            this.isSaving = true
            this.location.$create()
                .then(({ data }) => {
                    this.isSaving = false
                    this.modalOptions.modalOpen = false
                    this.$router.push({
                        name: 'locations.detail',
                        params: { id: data.id }
                    })
                })
                .catch(() => {
                    this.isSaving = false
                })

            return false
        },
        update() {
            this.isSaving = true
            this.location.$update()
                .then(() => {
                    this.isSaving = false
                    this.modalOptions.modalOpen = false
                })

            return false
        },
        remove() {
            this.$confirm({
                title: 'Confirm',
                message:
                    'Are you sure you want to remove this location? Courses in this location will no longer work.'
            })
                .then(() => {
                    return this.location.$remove()
                })
                .then(() => {
                    this.$router.push({ name: 'settings.locations' })
                })
        }
    }
}
</script>

<style lang="stylus"></style>
